














































import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { localStore } from '@/_utils/localstore'
import FlashMessage from '@/components/common/FlashMessage.vue'

@Component({
  components: { FlashMessage },
  computed: {
    ...mapState('common', {
      flashMessages: 'messages'
    })
  }
})
export default class UserPage extends Vue {
  private clickLogout(): void {
    localStore.removeItem('user')
  }

  private handleChangeLang(lang: string): void {
    localStore.setItem('lang', lang)
    location.reload(true)
  }
}
